export default __webpack_public_path__ + "static/media/img5.a88eb576.png";